import React from 'react'

export const ActivityTimelineAsync = React.lazy(() => import('./activity-timeline'))
